import React from 'react';
import { IconPackage, IconClipboardList } from '@tabler/icons-react';
import { getNoun } from '@utils/lib/getNoun';
import { OfferCard } from './offer-card';
import s from './interactive-message.module.scss';

// Fallback-рендер предложения пакета по payload (пока сообщение pending
// и серверный card ещё не пришёл) — тот же layout и детали, что у
// PackageOfferEntityCard, только без статуса и кнопок.
export const PackageOfferCard = ({ message, isMine }) => {
  const payload = message.payload || {};

  const title = payload.title || payload.name || 'Предложение пакета';
  const lessonsCount = payload.lessons_count || payload.count;
  const price = payload.price;

  return (
    <>
      <OfferCard icon={<IconPackage size={20} />} title={title} message={message}>
        <div className={s.chips}>
          {lessonsCount > 0 && (
            <span className={s.chip}>
              <IconClipboardList size={14} />
              {lessonsCount} {getNoun(lessonsCount, 'занятие', 'занятия', 'занятий')}
            </span>
          )}
          {price > 0 && (
            <span className={s.chip}>
              {Number(price).toLocaleString('ru-RU')} ₽
            </span>
          )}
        </div>
      </OfferCard>
      {isMine && <span className={s.statusText}>Отправлено ученику</span>}
    </>
  );
};
